import { connect } from 'react-redux';

import JSX from '../Dashboard';

const mapStateToProps = (state) => ({
    session: state.session,
    tenants: state.tenants
});

export default connect(mapStateToProps)(JSX);
